import React from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"

import SiteWrapper from "containers/layouts/SiteWrapper"
import PageWrapper from "containers/layouts/PageWrapper"
import AdminWrapper from "containers/layouts/AdminWrapper"

import PrivateRoute from "guards/PrivateRoute"
import NotFound from "components/Page404"

// views
const Home = React.lazy(() => import("screens/website/Homepage"))
const About = React.lazy(() => import("screens/website/About"))
const MapView = React.lazy(() => import("screens/website/MapView"))
// const News = React.lazy(() => import("screens/website/News"))
// const Requests = React.lazy(() => import("screens/website/Requests"))
const Contact = React.lazy(() => import("screens/website/Contact"))
// const FAQPage = React.lazy(() => import("screens/website/FAQ"))
const Services = React.lazy(() => import("screens/website/Services"))
const ServicePage = React.lazy(() => import("screens/website/ServicePage"))
const TermsConditions = React.lazy(() => import("screens/website/Termsconditions"))
const PrivacyPolicy = React.lazy(() => import("screens/website/PrivacyPolicy"))

//auth views
const Login = React.lazy(() => import("screens/auth/Login"))
// const Signup = React.lazy(() => import("screens/auth/Signup"))
const AcceptInvite = React.lazy(() => import("screens/auth/AcceptInvite"))
const ChangePassword = React.lazy(() => import("screens/auth/Changepassword"))
const ForgotPassword = React.lazy(() => import("screens/auth/Forgotpassword"))

// admin Views
const Dashboard = React.lazy(() => import("screens/dashboard/Dashboard"))
// const Blank = React.lazy(() => import("screens/dashboard/Blank"))
const Issues = React.lazy(() => import("screens/dashboard/Issues"))
const Users = React.lazy(() => import("screens/dashboard/Users"))
const Surveyors = React.lazy(() => import("screens/dashboard/Surveyors"))
const Permissions = React.lazy(() => import("screens/dashboard/Permissions"))
// const Revisions = React.lazy(() => import("screens/dashboard/Revisions"))
//app views
const Plans = React.lazy(() => import("screens/dashboard/Plans"))
// const Records = React.lazy(() => import("screens/dashboard/Records"))
// const Settings = React.lazy(() => import("screens/dashboard/Settings"))
const Profile = React.lazy(() => import("screens/dashboard/Profile"))
const FileExplorer = React.lazy(() => import("screens/dashboard/FileExplorer"))
const FileBrowser = React.lazy(() => import("screens/dashboard/FileBrowser"))
const MapViewer = React.lazy(() => import("screens/dashboard/MapViewer"))

export default () => {
    return (
        <Router>
            <Switch>
                <Route path="/login" component={Login} />
                {/* <Route path="/register" component={Signup} /> */}
                <Route path="/invite" component={AcceptInvite} />
                {/* <Route path="/register" component={AcceptInvite} />*/}

                <Route path="/changepassword/:token?" component={ChangePassword} />
                <Route exact path="/forgotpassword" component={ForgotPassword} />

                <PrivateRoute path="/app/:path?" exact>
                    <PageWrapper>
                        <Switch>
                            <Route exact path="/app" component={Plans} />
                            <Route exact path="/app/database" component={Plans} />
                            <Route exact path="/app/map" component={MapViewer} />
                            {/* <Route exact path="/app/files" component={FileExplorer} /> */}
                            <Route exact path="/app/files" component={FileBrowser} />
                            {/* <Route exact path="/app/blank" component={Blank} /> */}
                            <Route exact path="/app/profile" component={Profile} />
                            <Route component={NotFound} />
                        </Switch>
                    </PageWrapper>
                </PrivateRoute>

                <Route path="/admin/:path?" exact>
                    <AdminWrapper>
                        <Switch>
                            <Route path="/admin" exact component={Dashboard} />
                            <Route exact path="/admin/dashboard" component={Dashboard} />
                            <Route exact path="/admin/issues" component={Issues} />
                            <Route exact path="/admin/users" component={Users} />
                            <Route exact path="/admin/surveyors" component={Surveyors} />
                            <Route
                                exact
                                path="/admin/permissions"
                                component={Permissions}
                            />
                            {/* <Route exact path="/admin/revisions" component={Revisions} />
                            <Route
                                path="/admin/settings/:topicId?"
                                component={Settings}
                            /> */}
                            <Route component={NotFound} exact path="/admin/*" />
                        </Switch>
                    </AdminWrapper>
                </Route>

                <Route>
                    <SiteWrapper>
                        <Switch>
                            <Route path="/" exact component={Home} />
                            <Route path="/about" component={About} />
                            <Route exact path="/services" component={Services} />
                            <Route
                                exact
                                path="/services/:service"
                                component={ServicePage}
                            />
                            <Route path="/contact" component={Contact} />
                            {/* <Route path="/map" component={MapView} /> */}
                            <Route path="/termsconditions" component={TermsConditions} />
                            <Route path="/privacypolicy" component={PrivacyPolicy} />
                            {/* <Route path="/requests" component={Requests} />
                            <Route path="/contact" component={Contact} />
                            <Route path="/faq" component={FAQPage} />
                            <Route path="/services" component={Services} />
                            <Route path="/news" component={News} /> */}
                            <Route component={NotFound} exact path="*" />
                        </Switch>
                    </SiteWrapper>
                </Route>

                {/* <Route exact path="/404" component={NotFound} />
                <Route path="*" component={NotFound} /> */}
            </Switch>
        </Router>
    )
}
